import { useMutation } from '@apollo/client/react';
import { useSetAtom } from 'jotai';
import { useResetAtom } from 'jotai/utils';
import { useCallback, useEffect, useState } from 'react';

import { DeactivateFollowupMessageDocument } from '~/graphql/generated/graphql';
import {
  deleteMedicationFollowupMessageModalState,
  eventPageInfoState,
  patientDetailDialogMessageState,
} from '~/state/partials/patient_detail_dialog/atoms';

import { useBuildRefetchQueries } from '../NewMedicationFollowupMessagePane/InputPanel/use-build-refetch_queries';

export const useDeactivateFollowupMessage = () => {
  const refetchQueries = useBuildRefetchQueries();
  const [isDeactivating, setIsDeactivating] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const resetDeleteMedicationFollowupMessageModalState = useResetAtom(
    deleteMedicationFollowupMessageModalState,
  );
  const setEventInfoState = useSetAtom(eventPageInfoState);
  const setPatientDetailDialogMessageState = useSetAtom(patientDetailDialogMessageState);

  const [deactivateMessage, { data }] = useMutation(DeactivateFollowupMessageDocument, {
    refetchQueries,
  });

  useEffect(() => {
    if (!data?.deactivateMedicationFollowupMessage) return;

    setEventInfoState((_stagte) => ({
      ..._stagte,
      isResetEvent: true,
      page: 1,
      perPage: 20,
    }));
    setPatientDetailDialogMessageState((_state) => ({
      ..._state,
      selectedMessageId: null,
    }));
  }, [data, setEventInfoState, setPatientDetailDialogMessageState]);

  const deactivate = useCallback(
    async (messageId: string) => {
      setIsDeactivating(true);
      setError(null);

      try {
        await deactivateMessage({
          variables: {
            input: {
              medicationFollowupMessageId: messageId,
            },
          },
        });

        resetDeleteMedicationFollowupMessageModalState();
      } catch (error) {
        setError(error?.message || 'エラーが発生しました');
      }
      setIsDeactivating(false);
    },
    [deactivateMessage, resetDeleteMedicationFollowupMessageModalState],
  );

  return {
    isDeactivating,
    error,
    deactivate,
  };
};
